"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainSemanticVersion = void 0;
var ChainSemanticVersion = /** @class */ (function () {
    /**
     *
     * @param info is a version string, starts with 'v' and followed by semver seperated by '. Example 'v4.0.1'
     *
     */
    function ChainSemanticVersion(info) {
        this.semverString = this.stripReleaseCandidate(this.stripLeadingV(info));
    }
    ChainSemanticVersion.prototype.supportsLeap3Features = function () {
        var versionObject = this.getMajorMinorVersion();
        // must be major version 3 with minor version 1 or better
        // note v3.1.0-rc1 is a pre-v3.1.0 release and does not support 3.0 features
        return (
        // better then 3 ok!
        versionObject.major > 3 ||
            // version 3 must be version 1 or better
            (versionObject.major == 3 &&
                ((versionObject.minor == 1 && !this.semverString.hasReleaseCandidate)
                    ||
                        versionObject.minor > 1)));
    };
    ChainSemanticVersion.prototype.supportsLeap4Features = function () {
        var versionObject = this.getMajorMinorVersion();
        // must be major version 4 with minor version 0 or better
        // note v4.0.0-rc1 is a pre-v4.0.0 release and does not support 4.0 features
        return (
        // better then 4 ok!
        versionObject.major > 4 ||
            (versionObject.major == 4 && versionObject.minor > 0) ||
            // RC versions of v4.0.0 will not work. RC version of other version will work
            // Treat patch level undefined as patch level 0
            (versionObject.major == 4 &&
                !(versionObject.minor == 0 &&
                    (versionObject.patch == 0 || versionObject.patch == null) &&
                    this.semverString.hasReleaseCandidate)));
    };
    ChainSemanticVersion.prototype.stripLeadingV = function (info) {
        if (info.startsWith('v')) {
            return info.slice(1);
        }
        else {
            return info;
        }
    };
    ChainSemanticVersion.prototype.stripReleaseCandidate = function (info) {
        var versionString = info.split('-');
        if (versionString.length > 1) {
            return {
                version: versionString[0],
                hasReleaseCandidate: true,
                parsingError: false,
            };
        }
        return {
            version: info,
            hasReleaseCandidate: false,
            parsingError: false,
        };
    };
    ChainSemanticVersion.prototype.getMajorMinorVersion = function () {
        var semVersions = this.semverString.version.split('.');
        // expect at least major and minor version
        if (semVersions.length < 2) {
            this.semverString.parsingError = true;
            return { major: 0, minor: 0 };
        }
        // expect a number
        if (isNaN(parseInt(semVersions[0])) || isNaN(parseInt(semVersions[1]))) {
            this.semverString.parsingError = true;
            return { major: 0, minor: 0 };
        }
        var patch = undefined;
        if (semVersions.length > 2 && !isNaN(parseInt(semVersions[2]))) {
            patch = parseInt(semVersions[2]);
        }
        return { major: parseInt(semVersions[0]), minor: parseInt(semVersions[1]), patch: patch };
    };
    return ChainSemanticVersion;
}());
exports.ChainSemanticVersion = ChainSemanticVersion;
//# sourceMappingURL=ChainSemanticVersion.js.map